import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

const PostPreview = ({ post, ...rest }) => {
  if (post.mainImage) {
    post.mainImage.sizes.aspectRatio = 2
  }

  return (
    <article style={{ marginBottom: '1rem' }}>
      <Link to={`/${post.slug}`} style={{ marginBottom: '0.5rem', display: 'block' }}>
        <Img sizes={post.mainImage.sizes} />
      </Link>
      <div>
        <p className="title is-3" style={{ paddingBottom: '0.25rem' }}>
          <Link to={`/${post.slug}`}>{post.title}</Link>
        </p>
        <p className="subtitle is-5">
          {post.description}
        </p>
        <div className="tags">
          {post.tags.map((tag, idx) => <span key={idx} className="tag is-light">{tag}</span>)}
        </div>
      </div>
    </article>
  )
}

export default PostPreview



// WEBPACK FOOTER //
// ./src/components/PostPreview.jsx